export default __webpack_public_path__ + "6bd37b1a0b24e661db8c744a459db418.ttf";